import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import CookieConsent from "react-cookie-consent"
import { useLocale } from '../../localization/LocaleContext';
import { getLocaleOptions, switchLocaleInPathname } from '../../localization/locale';


function Footer(){
    const dateString = new Date().getFullYear();
    const history = useHistory();
    const location = useLocation();
    const { locale, setLocalePreference, t, toLocalizedPath } = useLocale();

    function handleLocaleChange(nextLocale) {
        setLocalePreference(nextLocale);
        history.push({
            hash: location.hash,
            pathname: switchLocaleInPathname(location.pathname, nextLocale),
            search: location.search
        });
    }

    return(
        <footer className="spt-90 end-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="Invoice Point logo" />
                    </div>
                    
                
                <div className="col-lg-4">
                        <div className="flex-end tab-flex-end">
                            <ul className="footer-ul">
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('home')}>
                                        {t('nav.home')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('freelancers')}>
                                        {t('nav.freelancers')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('smallBusiness')}>
                                        {t('nav.smallBusiness')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('organization')}>
                                        {t('nav.organization')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('pricing')}>
                                        {t('nav.pricing')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 sb-90">
                        <div className="flex-end tab-flex-end">
                            <ul className="footer-ul">
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('contractors')}>
                                        {t('niche.contractors.heroHighlight')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('handymen')}>
                                        {t('niche.handymen.heroHighlight')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('cleaners')}>
                                        {t('niche.cleaners.heroHighlight')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('faqs')}>
                                        {t('nav.faqs')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('privacyPolicy')}>
                                        {t('nav.privacy')}
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to={toLocalizedPath('termsOfService')}>
                                        {t('nav.terms')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="white-line"></div>
                    </div>
                </div>
                <div className="row pt-20 pb-20">
                    <div className="col-sm-6">
                        <div className="flex-start">
                            <p className="footer-copyright">
                                {t('footer.copyright', { year: dateString })}
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="flex-end footer-language-block">
                            <div className="language-switcher" aria-label={t('footer.languageLabel')}>
                                <label className="language-switcher-label" htmlFor="footer-language-select">
                                    {t('footer.languageLabel')}
                                </label>
                                <select
                                    className="language-switcher-select"
                                    id="footer-language-select"
                                    onChange={(event) => handleLocaleChange(event.target.value)}
                                    value={locale}
                                >
                                    {getLocaleOptions().map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-end">
                            <p className="footer-copyright">
                                {t('footer.allRightsReserved')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <CookieConsent
                buttonText={t('cookie.button')}
                style={{ background: "rgb(25, 29, 40, 0.9)" }}
                buttonStyle={{ background: "#FFF", color: "#000", fontSize: "16px" }}>
                {t('cookie.messageBeforeLink')}<Link to={toLocalizedPath('cookiePolicy')}>{t('cookie.linkLabel')}</Link>{t('cookie.messageAfterLink')}
            </CookieConsent>
        </footer>
    )
}
export default Footer;